export const orderStatusMap = {
  draft: 'Utkast',
  canceled: 'Kansellert',
  unpaid: 'Ubetalt',
  paid: 'Oppgjort',
  invoiced: 'Fakturert',
};
